import { render, staticRenderFns } from "./addContact.vue?vue&type=template&id=04cef68b&scoped=true&"
import script from "./addContact.vue?vue&type=script&lang=js&"
export * from "./addContact.vue?vue&type=script&lang=js&"
import style0 from "./addContact.vue?vue&type=style&index=0&id=04cef68b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cef68b",
  null
  
)

export default component.exports